import { Route } from 'react-router-dom';
import {
  outOfNavRoutes,
  routes
} from '../utils/constants/ownerPensionerRoutes';
import { OwnerPensionerDashboard } from '../routes/dashboards/OwnerPensionerDashboard';
import { SupervisionsRouter } from '../routes/usersShows/supervisions/SupervisionsRouter';
import { ViewAdsRouter } from '../routes/usersShows/view-ads/ViewAdsRouter';
import { MySubscriptionRouter } from '../routes/usersShows/subscription/MySubscriptionRouter';
import { DocumentsRouter } from '../routes/usersShows/documents/DocumentsRouter';
import { BaseUserRouter } from './BaseUserRouter';

/**
 * PensionerRouter component.
 * @component
 *
 * Router component for pensioner operations.
 * @returns {ReactElement} The PensionerRouter component.
 */
export const PensionerRouter = () => (
  <BaseUserRouter
    outOfNavRoutes={outOfNavRoutes}
    dashboardComponent={<OwnerPensionerDashboard />}
    dashboardPath={routes.DASHBOARD}
    additionalRoutes={[
      <Route
        key="supervisions"
        path={`${routes.SUPERVISIONS}/*`}
        element={<SupervisionsRouter />}
      />,
      <Route
        key="view-ads"
        path={`${routes.VIEW_ADS}/*`}
        element={<ViewAdsRouter />}
      />,
      <Route
        key="subscription"
        path={`${routes.SUBSCRIPTION}/*`}
        element={<MySubscriptionRouter />}
      />,
      <Route
        key="documents"
        path={`${routes.DOCUMENTS}/*`}
        element={<DocumentsRouter />}
      />
    ]}
  />
);
